import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import topBg from '../../Common/Assets/Images/home1-top-bg.png';
import BottumBg from '../../Common/Assets/Images/home1-bottum-bg.png';
import maleIcon from '../../Common/Assets/Images/Male-color.png';
import femaleIcon from '../../Common/Assets/Images/female-color.png';
import '../../Common/CSS/Style.css';

// API Configuration
const API_CONFIG = {
  development: {
    baseURL: '', // Use proxy in development
    getMatchURL: '/webhook/getMatch',
    getMatchersCountURL: '/webhook/getMatchersCount',
  },
  production: {
    baseURL: 'https://n8n-prod.shplishka.com',
    getMatchURL: 'https://n8n-prod.shplishka.com/webhook/getMatch',
    getMatchersCountURL: 'https://n8n-prod.shplishka.com/webhook/getMatchersCount',
  },
};

const currentConfig =
  process.env.NODE_ENV === 'development' ? API_CONFIG.development : API_CONFIG.production;

function Mothers() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: '',
    phone: '', // Single phone field for react-phone-input-2
    gender: '',
    age: '',
    seekingGender: '',
    religiousView: '',
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [userCount, setUserCount] = useState(0);

  // Religious view data from SelectLifestyle component
  const religiousViewData = [
    { english: 'Secular', hebrew: 'חילוני' },
    { english: 'Traditional', hebrew: 'מסורתי' },
    { english: 'Religious', hebrew: 'דתי' },
  ];

  useEffect(() => {
    const fetchUserCount = async () => {
      try {
        const response = await fetch(currentConfig.getMatchersCountURL);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const targetUserCount = parseInt(data.result.aggregateFields.total_count.integerValue, 10);

        if (!isNaN(targetUserCount)) {
          const duration = 2000; // Animation duration
          let startTimestamp = null;

          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const currentCount = Math.floor(progress * targetUserCount);
            setUserCount(currentCount);
            if (progress < 1) {
              window.requestAnimationFrame(step);
            }
          };
          window.requestAnimationFrame(step);
        }
      } catch (error) {
        console.error('Failed to fetch user count:', error);
        setUserCount(6405); // Fallback to a default value
      }
    };

    fetchUserCount();
  }, []);

  const generateUniqueId = () => {
    return Date.now().toString() + Math.random().toString(36).substr(2, 9);
  };

  const formatPhoneNumber = (phone) => {
    // react-phone-input-2 already provides the phone in international format
    // Just ensure it has the + prefix and format with dash
    if (!phone) return '';

    // If phone doesn't start with +, add it
    let formattedPhone = phone.startsWith('+') ? phone : `+${phone}`;

    // For Israeli numbers, format as +972-XXXXXXXXX
    if (formattedPhone.startsWith('+972')) {
      const number = formattedPhone.replace('+972', '');
      return `+972-${number}`;
    }

    // For other countries, find the country code and format similarly
    // This is a basic implementation, you might want to enhance it for other countries
    return formattedPhone;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      phone: value,
    }));

    if (errors.phone) {
      setErrors((prev) => ({
        ...prev,
        phone: '',
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = 'שם השדכנית נדרש';
    if (!formData.phone.trim()) newErrors.phone = 'טלפון השדכנית נדרש';
    if (!formData.gender) newErrors.gender = 'יש לבחור מגדר';
    if (!formData.age) newErrors.age = 'גיל נדרש';
    if (!formData.seekingGender) newErrors.seekingGender = 'יש לבחור מה הוא/היא מחפש/ת';
    if (formData.religiousView === '') newErrors.religiousView = 'יש לבחור אורח חיים';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsLoading(true);
      try {
        const genderValue = formData.gender === 'גבר' ? 0 : formData.gender === 'אישה' ? 1 : -1;
        const seekingGenderValue =
          formData.seekingGender === 'גבר' ? 0 : formData.seekingGender === 'אישה' ? 1 : -1;

        const transformedData = {
          originalData: formData,
          gender: genderValue !== -1 ? parseInt(genderValue) : 0,
          seeking_gender: seekingGenderValue !== -1 ? parseInt(seekingGenderValue) : 0,
          religious_view: parseInt(formData.religiousView) || 0,
          age: parseInt(formData.age) || 0,
          single_profile_id: generateUniqueId(),
          exclude_single_id: '',
          seeker_name: formData.fullName,
          seeker_phone: formatPhoneNumber(formData.phone),
        };

        console.log('Sending data to webhook:', transformedData);
        console.log('Current URL:', window.location.href);
        console.log('Webhook URL:', currentConfig.getMatchURL);

        const response = await fetch(currentConfig.getMatchURL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(transformedData),
        });

        console.log('Response status:', response.status);

        // Send additional data to motherMatcherDetails webhook
        try {
          const motherMatcherData = {
            fullName: formData.fullName,
            phone: formatPhoneNumber(formData.phone),
            timestamp: new Date().toISOString(),
          };

          console.log('Sending data to motherMatcherDetails webhook:', motherMatcherData);

          const motherMatcherResponse = await fetch(
            'https://n8n-prod.shplishka.com/webhook/motherMatcherDetails',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify(motherMatcherData),
            },
          );

          console.log('MotherMatcher webhook response status:', motherMatcherResponse.status);
        } catch (motherMatcherError) {
          console.error('MotherMatcher webhook error:', motherMatcherError);
          // Continue with the main flow even if this webhook fails
        }

        if (response.ok) {
          const responseData = await response.json();
          console.log('Response data:', responseData);
          const matchCount = responseData?.[0]?.count ?? '0';
          const count = parseInt(matchCount);

          navigate('/match-results', {
            state: { count, matchCount, seekerName: formData.fullName, success: true },
          });
        } else {
          console.error('Error response:', response);
          console.log(
            'Webhook failed with status:',
            response.status,
            'Using mock data for testing...',
          );

          // Use mock data when webhook returns error status
          console.log('Navigating to /match-results with mock data...');
          navigate('/match-results', {
            state: {
              count: 0,
              matchCount: '0',
              matcherName: formData.fullName,
              success: false,
              error: 'אירעה שגיאה בשליחת הבקשה. נסה שנית.',
            },
          });
        }
      } catch (error) {
        console.error('Fetch error:', error);

        // For testing: provide mock data when webhook fails
        console.log('Using mock data for testing...');
        navigate('/match-results', {
          state: {
            count: 0,
            matchCount: '0',
            matcherName: formData.fullName,
            success: false,
            error: 'אירעה שגיאה בחיבור לשרת. נסה שנית.',
          },
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <style>{`
        .mothers-page {
          font-family: 'Heebo', sans-serif;
          direction: rtl;
        }
        .user-counter-section {
          text-align: center;
          padding: 1.5rem;
          margin: 0 auto 2.5rem auto;
          background-color: rgba(238, 44, 70, 0.05);
          border-radius: 12px;
          border: 1px solid rgba(238, 44, 70, 0.1);
          max-width: 400px;
        }
        .user-counter-section .counter-value {
            font-size: 3rem;
            font-weight: 700;
            color: #ee2c46;
            line-height: 1.2;
        }
        .user-counter-section p {
            font-size: 1rem;
            color: #34495e;
            margin-top: 0.25rem;
            font-weight: 600;
        }
        .mothers-container {
          padding: 2rem 1rem;
          max-width: 650px;
          margin: 0 auto;
        }
        .mothers-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }
        .mothers-header .logo {
          max-width: 150px;
          margin-bottom: 1rem;
          display: block;
          margin-left: auto;
          margin-right: auto;
        }
        .mothers-header .matchers-logo {
          margin-bottom: 0.5rem;
        }
        .mothers-header .mothers-logo {
          margin-bottom: 2rem;
        }
        .mothers-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #2c3e50;
          line-height: 1.3;
        }
        .mothers-header p {
          font-size: 1.15rem;
          color: #7f8c8d;
          margin-top: 1rem;
        }
        .mothers-form {
          background-color: #ffffff;
          padding: 2.5rem;
          border-radius: 16px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.08);
          margin-top: 2rem;
        }
        .form-section {
          margin-bottom: 2.5rem;
          text-align: right;
        }
        .form-section:last-of-type {
          margin-bottom: 0;
        }
        .form-section h2 {
          font-size: 1.75rem;
          font-weight: 700;
          margin-bottom: 2rem;
          color: #34495e;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid #ee2c46;
          display: inline-block;
        }
        .form-group {
          margin-bottom: 1.5rem;
        }
        .form-group label {
          display: block;
          font-weight: 600;
          margin-bottom: 0.5rem;
          color: #34495e;
          font-size: 1rem;
        }
        .form-control {
          width: 100%;
          padding: 14px 20px;
          border-radius: 8px;
          border: 1px solid #bdc3c7;
          background-color: #ecf0f1;
          font-size: 1rem;
          transition: all 0.3s ease;
          -webkit-appearance: none;
          text-align: right;
        }
        .form-control:focus {
          outline: none;
          border-color: #ee2c46;
          box-shadow: 0 0 0 4px rgba(238, 44, 70, 0.1);
          background-color: #fff;
        }
        .error-input-box-alert {
          border-color: #e74c3c !important;
        }
        .error-message-box-signin {
          color: #e74c3c;
          font-size: 0.875rem;
          margin-top: 0.5rem;
          text-align: right;
        }

        .submit-btn {
          width: 100%;
          padding: 16px 20px;
          border-radius: 8px;
          background: linear-gradient(45deg, #f06, #ee2c46);
          color: #fff;
          font-size: 1.25rem;
          font-weight: bold;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 5px 15px rgba(238, 44, 70, 0.3);
          margin-top: 2rem;
        }
        .submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(238, 44, 70, 0.4);
        }
        .submit-btn:disabled {
          background: #bdc3c7;
          cursor: not-allowed;
          box-shadow: none;
          transform: none;
        }
        .gender-selection-buttons {
          display: flex;
          justify-content: center;
          gap: 2rem;
          margin-top: 1rem;
        }
        .gender-button {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;
          border-radius: 12px;
          border: 2px solid #bdc3c7;
          background-color: #ecf0f1;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 90px;
          height: 120px;
        }
        .gender-button:hover {
          background-color: rgba(238, 44, 70, 0.05);
          border-color: #ee2c46;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }
        .gender-button.active {
          background-color: rgba(238, 44, 70, 0.1);
          border-color: #ee2c46;
          box-shadow: 0 5px 20px rgba(238, 44, 70, 0.3);
          transform: translateY(-2px);
        }
        .gender-button img {
          width: 70px;
          height: auto;
          object-fit: contain;
          max-height: 100px;
        }
        .religious-view-selection {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-top: 1rem;
        }
        .religious-option {
          padding: 12px 16px;
          border-radius: 8px;
          border: 2px solid #bdc3c7;
          background-color: #ecf0f1;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 0.9rem;
          font-weight: 600;
          color: #34495e;
          text-align: center;
        }
        .religious-option:hover {
          background-color: rgba(238, 44, 70, 0.05);
          border-color: #ee2c46;
          transform: translateY(-1px);
          box-shadow: 0 3px 10px rgba(0,0,0,0.1);
        }
        .religious-option.active {
          background-color: #ee2c46;
          border-color: #ee2c46;
          color: white;
          box-shadow: 0 3px 15px rgba(238, 44, 70, 0.3);
          transform: translateY(-1px);
        }
        .react-tel-input {
          direction: ltr !important;
          text-align: left !important;  
        }
        .react-tel-input .form-control {
          width: 100% !important;
          height: 50px !important;
          font-size: 1rem !important;
          border-radius: 8px !important;
          border: 1px solid #bdc3c7 !important;
          background-color: #ecf0f1 !important;
          padding: 14px 20px 14px 60px !important;
          direction: ltr !important;
          text-align: left !important;
        }
        .react-tel-input .form-control:focus {
          border-color: #ee2c46 !important;
          box-shadow: 0 0 0 4px rgba(238, 44, 70, 0.1) !important;
          background-color: #fff !important;
        }
        .react-tel-input .flag-dropdown {
          border: 1px solid #bdc3c7 !important;
          border-radius: 8px 0 0 8px !important;
          background-color: #ecf0f1 !important;
        }
        .react-tel-input .flag-dropdown:hover {
          background-color: #fff !important;
        }
        .react-tel-input .selected-flag {
          padding: 0 8px !important;
        }
        .react-tel-input.error .form-control {
          border-color: #e74c3c !important;
        }
      `}</style>
      <div className="main-home mothers-page">
        <div className="universal-background-top">
          <img className="universal-background-top-img" src={topBg} alt="background" />
        </div>

        <div className="mothers-container">
          <header className="mothers-header">
            <img
              className="img-fluid logo matchers-logo"
              alt="matchers logo"
              src="./images/logo.png"
            />
            <img
              className="img-fluid logo mothers-logo"
              alt="mothers logo"
              src="./images/mothers-logo1.png"
            />
            <h1>אמהות לא אוגרות רווקים</h1>
            <p>הירשמי כדי לקבל תעדוף בהצעות באפליקציית Matchers בט״ו באב הקרוב</p>
          </header>

          <div className="user-counter-section">
            <div className="counter-value">{userCount.toLocaleString()}</div>
            <p>משתמשים שכבר הצטרפו...</p>
          </div>

          <main>
            <form onSubmit={handleSubmit} className="mothers-form" noValidate>
              <div className="form-section">
                <h2>מי את?</h2>
                <div className="form-group">
                  <label htmlFor="fullName">שם השדכנית</label>
                  <input
                    id="fullName"
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="השם שלך"
                    className={`form-control ${errors.fullName ? 'error-input-box-alert' : ''}`}
                  />
                  {errors.fullName && (
                    <div className="error-message-box-signin">{errors.fullName}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="phone">טלפון השדכנית</label>
                  <PhoneInput
                    country={'il'} // Default to Israel
                    value={formData.phone}
                    onChange={handlePhoneChange}
                    placeholder="הטלפון שלך"
                    containerClass={errors.phone ? 'error' : ''}
                    inputProps={{
                      name: 'phone',
                      required: true,
                      autoFocus: false,
                    }}
                    preferredCountries={['il', 'us', 'gb']}
                    enableSearch={true}
                    searchPlaceholder="חפש מדינה..."
                  />
                  {errors.phone && <div className="error-message-box-signin">{errors.phone}</div>}
                </div>
              </div>

              <div className="form-section">
                <h2>את מי את רוצה לשדך?</h2>
                <div className="form-group">
                  <label>מגדר הרווק/ה:</label>
                  <div className="gender-selection-buttons">
                    <button
                      type="button"
                      className={`gender-button ${formData.gender === 'גבר' ? 'active' : ''}`}
                      onClick={() => {
                        setFormData((prev) => ({ ...prev, gender: 'גבר' }));
                        if (errors.gender) {
                          setErrors((prev) => ({ ...prev, gender: '' }));
                        }
                      }}
                    >
                      <img src={maleIcon} alt="Male" />
                    </button>
                    <button
                      type="button"
                      className={`gender-button ${formData.gender === 'אישה' ? 'active' : ''}`}
                      onClick={() => {
                        setFormData((prev) => ({ ...prev, gender: 'אישה' }));
                        if (errors.gender) {
                          setErrors((prev) => ({ ...prev, gender: '' }));
                        }
                      }}
                    >
                      <img src={femaleIcon} alt="Female" />
                    </button>
                  </div>
                  {errors.gender && <div className="error-message-box-signin">{errors.gender}</div>}
                </div>
                <div className="form-group">
                  <label htmlFor="age">גיל הרווק/ה:</label>
                  <input
                    id="age"
                    type="number"
                    name="age"
                    value={formData.age}
                    onChange={handleInputChange}
                    placeholder="לדוגמה: 28"
                    min="18"
                    max="99"
                    className={`form-control ${errors.age ? 'error-input-box-alert' : ''}`}
                  />
                  {errors.age && <div className="error-message-box-signin">{errors.age}</div>}
                </div>
                <div className="form-group">
                  <label>אורח חיים:</label>
                  <div className="religious-view-selection">
                    {religiousViewData.map((view, index) => (
                      <button
                        key={index}
                        type="button"
                        className={`religious-option ${formData.religiousView === index.toString() ? 'active' : ''}`}
                        onClick={() => {
                          setFormData((prev) => ({ ...prev, religiousView: index.toString() }));
                          if (errors.religiousView) {
                            setErrors((prev) => ({ ...prev, religiousView: '' }));
                          }
                        }}
                      >
                        {view.hebrew}
                      </button>
                    ))}
                  </div>
                  {errors.religiousView && (
                    <div className="error-message-box-signin">{errors.religiousView}</div>
                  )}
                </div>
              </div>

              <div className="form-section">
                <h2>מה הרווק/ה מחפש/ת</h2>
                <div className="form-group">
                  <div className="gender-selection-buttons">
                    <button
                      type="button"
                      className={`gender-button ${formData.seekingGender === 'גבר' ? 'active' : ''}`}
                      onClick={() => {
                        setFormData((prev) => ({ ...prev, seekingGender: 'גבר' }));
                        if (errors.seekingGender) {
                          setErrors((prev) => ({ ...prev, seekingGender: '' }));
                        }
                      }}
                    >
                      <img src={maleIcon} alt="Male" />
                    </button>
                    <button
                      type="button"
                      className={`gender-button ${formData.seekingGender === 'אישה' ? 'active' : ''}`}
                      onClick={() => {
                        setFormData((prev) => ({ ...prev, seekingGender: 'אישה' }));
                        if (errors.seekingGender) {
                          setErrors((prev) => ({ ...prev, seekingGender: '' }));
                        }
                      }}
                    >
                      <img src={femaleIcon} alt="Female" />
                    </button>
                  </div>
                  {errors.seekingGender && (
                    <div className="error-message-box-signin">{errors.seekingGender}</div>
                  )}
                </div>
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? 'מחפש...' : 'בדוק פוטנציאל שידוך'}
              </button>
            </form>
          </main>
        </div>

        <div className="universal-background-bottom select-detail-universal-bac-bottum">
          <img className="universal-background-bottom-img" src={BottumBg} alt="background" />
        </div>
      </div>
    </>
  );
}

export default Mothers;
